import React from 'react';

const BackButton = () => {
  return (
      <div className="linktext">
          <a href="#/schools"><i className="fas fa-angle-left"></i> Browse schools</a>
      </div>
  )
}

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/BackButton.js